import { render, staticRenderFns } from "./shenList.vue?vue&type=template&id=3f1b5156&scoped=true&"
import script from "./shenList.vue?vue&type=script&lang=js&"
export * from "./shenList.vue?vue&type=script&lang=js&"
import style0 from "./shenList.vue?vue&type=style&index=0&id=3f1b5156&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1b5156",
  null
  
)

export default component.exports